exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, "\n.customLayout{\r\n    OVERFLOW-Y: auto; \r\n    /*background: url('./images/bg.jpg') no-repeat 4px 5px;*/\n}\r\n", "", {"version":3,"sources":["E:/eview/efview/src/components/masterplate/simpletree.vue"],"names":[],"mappings":";AACA;IACI,iBAAiB;IACjB,yDAAyD;CAC5D","file":"simpletree.vue","sourcesContent":["\n.customLayout{\r\n    OVERFLOW-Y: auto; \r\n    /*background: url('./images/bg.jpg') no-repeat 4px 5px;*/\n}\r\n"],"sourceRoot":""}]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"sourceMap":true}!./node_modules/vue-loader/lib/style-compiler?{"optionsId":"0","vue":true,"scoped":false,"sourceMap":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/masterplate/simpletree.vue
// module id = 1389
// module chunks = 0